import { getId, Modal } from '@fluentui/react';
import EditOrderPriceView from './EditOrderPriceView';
import ApproveOrderView from './ApproveOrderView';
import ChangeOrderWarehouseView from './ChangeOrderWarehouseView';
import EditOrderProductView from './EditOrderProductView';
import { UserRolesModel } from '../../../../accounts/models/UserRolesInfo';
import { StyleUtils } from '../../../../common/views/StyleUtils';
import { Utils } from '../../../../common/views/Utils';
import { ShortWebsiteModel } from '../../../../websites/models/WebsiteModel';
import { useOrderDetailVM } from '../../../viewmodels/OrderDetailVM';
import { useEffect, useRef } from 'react';
import OrderDetailHeaderView from './OrderDetailHeaderView';
import ChangeOrderWebsiteView from './ChangeOrderWebsiteView';

type OrderDetailProps = {
    id: number;
    userRoles: UserRolesModel;
    websiteOptions: ShortWebsiteModel[];
    onClose: () => void;
}

export default function OrderDetailView({
    id, userRoles, websiteOptions, onClose
}: OrderDetailProps) {
    const hasLoaded = useRef(false);
    const vm = useOrderDetailVM(id);

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.get();
    }, [vm]);

    const isMobile = window.innerWidth <= 500;
    const width6 = Utils.getColumnWidth(6, 12, 12);
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    function leftBlock() {
        if (vm.order == null || vm.order.id <= 0)
            return <></>;

        return <>
            <div className="box p-15">
                <EditOrderProductView
                    order={vm.order}
                    form={vm.productForm}
                    errorMessages={vm.errorMessages}
                    onSubmit={vm.editProduct}
                    loading={vm.loading}
                    showPicture={vm.showPicture}
                    setShowPicture={vm.setShowPicture}
                    onAddPicture={vm.addPicture}
                    onValueChange={vm.setProductField} />
            </div>

            <div className="box mt-20 p-15">
                <ChangeOrderWebsiteView
                    form={vm.websiteForm}
                    userRoles={userRoles}
                    loading={vm.loading}
                    options={websiteOptions}
                    onValueChange={vm.setWebsiteField}
                    onSubmit={vm.changeWebsite} />
            </div>
        </>;
    }

    const rightBlock = () => {
        if (vm.order == null || vm.order.id <= 0) return <></>;

        return <>
            <div className="box p-15">
                <ChangeOrderWarehouseView
                    order={vm.order}
                    userRoles={userRoles}
                    loading={vm.loading}
                    showWarehouseList={vm.showWarehouseList}
                    setShowWarehouseList={vm.setShowWarehouseList}
                    onUnassign={vm.unAssignWarehouse}
                    onAssign={vm.assignWarehouse}
                />
            </div>

            <div className="box mt-20 p-15">
                <EditOrderPriceView
                    order={vm.order}
                    form={vm.editForm}
                    loading={vm.loading}
                    setShowPicture={vm.setShowPicture}
                    onValueChange={vm.setEditField}
                    onSubmit={vm.edit}
                />
            </div>

            <div className="box mt-20 p-15">
                <ApproveOrderView
                    order={vm.order}
                    form={vm.approveForm}
                    userRoles={userRoles}
                    loading={vm.loading}
                    onValueChange={vm.setApproveField}
                    onSubmit={vm.approve}
                />
            </div>
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(1200)}
        >
            <OrderDetailHeaderView order={vm.order} showCustomer={true} onClose={onClose} />

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body"}>
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className={width6 + " mv-10"}>{leftBlock()}</div>
                        <div className={width6 + " mv-10"}>{rightBlock()}</div>
                    </div>
                </div>
            </div>
        </Modal>
    </>;
}